"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDoubleUpdaterCurried = exports.applyDoubleUpdater = void 0;
const sum_1 = require("./sum");
const applyDoubleUpdater = (updaters, outerUpdater, innerUpdater) => (containerState) => (0, sum_1.deconstruct)((l) => outerUpdater(l), (r) => innerUpdater(r), updaters)(containerState);
exports.applyDoubleUpdater = applyDoubleUpdater;
const applyDoubleUpdaterCurried = (outerUpdater, innerUpdater) => (updaters) => (containerState) => (0, sum_1.deconstruct)((l) => outerUpdater(l), (r) => innerUpdater(r), updaters)(containerState);
exports.applyDoubleUpdaterCurried = applyDoubleUpdaterCurried;
